// extracted by mini-css-extract-plugin
export var section = "industry-module--section--2fxOE";
export var inner = "industry-module--inner--3QtS_";
export var jsAnimInit = "industry-module--jsAnimInit--2s2WS";
export var imgWrap = "industry-module--imgWrap--2Y-2T";
export var contentWrap = "industry-module--contentWrap--2uP22";